/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input, OnChanges} from '@angular/core';

@Component({
  standalone: false,
  selector: 'adn-targeting-publisher-summary',
  template: `
    <strong *ngIf="negated">NOT:&nbsp;</strong>
    <ng-container *ngFor="let publisher of publishers; let last = last">
      <a *ngIf="linkTargets && publisher?.url" uiSref="app.inv.earnings-accounts.earnings-account" [uiParams]="{id: publisher?.id}">{{publisher?.name}}</a>
      <span *ngIf="!linkTargets || !publisher?.url">{{publisher?.name}}</span><span *ngIf="!last">, </span>
    </ng-container>
  `
})
export class PublisherSummaryComponent implements OnChanges {
  @Input() targets: any;
  @Input() linkTargets = false;

  publishers: any[] = [];
  negated = false;

  ngOnChanges(): void {
    const target = this.targets || {};
    this.negated = target.negated;
    this.publishers = target.earningsAccounts || [];
  }
}
